<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

<salonmonster-tap-retry
  *ngIf="errorOccurredWhileLoadingStylistPicker"
  (click)="onTapToReload()"
></salonmonster-tap-retry>

<smr-stylist-picker
  [stylistID]="stylistID"
  [readOnly]="readOnlyStylistPicker"
  (onInit)="onStylistPickerInit($event)"
  (stylistSelect)="onStylistSelect($event)"
  cssClass="smr-stylist-picker-for-text"
  [showAllStaff]="showAllStaff"
>
</smr-stylist-picker>

<form [formGroup]="marketingComposerForm">
  <ion-row>
    <ion-col class="ion-text-center ion-no-padding" size="12">
      <ion-item class="ion-no-padding" lines="none">
        <div class="email-label">Text</div>
        <ion-select
          formControlName="filterType"
          (ionChange)="filterChanged()"
          interface="popover"
        >
          <ion-select-option value="allclients">All clients</ion-select-option>
          <ion-select-option value="appointment"
            >Clients whose appointment is</ion-select-option
          >
          <ion-select-option value="spent">Clients who spent</ion-select-option>
          <ion-select-option value="birthday"
            >Clients whose birthday is</ion-select-option
          >
          <ion-select-option value="service"
            >Clients who had a service</ion-select-option
          >
        </ion-select>
      </ion-item>
    </ion-col>
  </ion-row>

  <ng-container [ngSwitch]="filterType.value">
    <div *ngSwitchCase="'appointment'">
      <ion-item class="ion-no-padding">
        <ion-select
          formControlName="appointmentBeforeAfterOption"
          (ionChange)="refreshNumberOfRecipients()"
        >
          <ion-select-option value="before">before</ion-select-option>
          <ion-select-option value="between">between</ion-select-option>
          <ion-select-option value="after">after</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label
          position="stacked"
          *ngIf="appointmentBeforeAfterOption.value == 'between'"
          >Start</ion-label
        >
        <ion-datetime
          formControlName="appointmentStartDateOption"
          displayFormat="MMMM DD YYYY"
          max="2022-12-31"
          (ionChange)="refreshNumberOfRecipients()"
        ></ion-datetime>
      </ion-item>
      <ion-item *ngIf="appointmentBeforeAfterOption.value == 'between'">
        <ion-label position="stacked">End</ion-label>
        <ion-datetime
          formControlName="appointmentEndDateOption"
          displayFormat="MMMM DD YYYY"
          max="2022-12-31"
          (ionChange)="refreshNumberOfRecipients()"
        ></ion-datetime>
      </ion-item>
    </div>

    <div *ngSwitchCase="'spent'">
      <ion-item class="ion-no-padding">
        <ion-select
          formControlName="spentRangeOption"
          (ionChange)="refreshNumberOfRecipients()"
        >
          <ion-select-option value="morethan">more than</ion-select-option>
          <ion-select-option value="lessthan">less than</ion-select-option>
          <ion-select-option value="between">between</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label>{{ currency }}</ion-label>
        <ion-input
          formControlName="spentStartPrice"
          type="number"
          (ionChange)="refreshNumberOfRecipients()"
        >
        </ion-input>
      </ion-item>
      <ion-item *ngIf="spentRangeOption.value == 'between'">
        <ion-label>{{ currency }}</ion-label>
        <ion-input
          formControlName="spentEndPrice"
          type="number"
          (ionChange)="refreshNumberOfRecipients()"
        ></ion-input>
      </ion-item>
    </div>

    <div *ngSwitchCase="'birthday'">
      <ion-item class="ion-no-padding">
        <ion-select
          formControlName="birthdayRangeOption"
          (ionChange)="refreshNumberOfRecipients()"
        >
          <ion-select-option value="ison">is on</ion-select-option>
          <ion-select-option value="between">between</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label
          position="stacked"
          *ngIf="birthdayRangeOption.value == 'between'"
          >Start</ion-label
        >
        <ion-datetime
          formControlName="birthdayStartDate"
          displayFormat="MMMM DD"
          max="2022-12-31"
          (ionChange)="refreshNumberOfRecipients()"
        ></ion-datetime>
      </ion-item>
      <ion-item *ngIf="birthdayRangeOption.value == 'between'">
        <ion-label position="stacked">End</ion-label>
        <ion-datetime
          formControlName="birthdayEndDate"
          displayFormat="MMMM DD"
          max="2022-12-31"
          (ionChange)="compareTwoDates()"
        ></ion-datetime>
      </ion-item>
    </div>

    <div *ngSwitchCase="'service'">
      <ion-item lines="none">
        <ion-label position="stacked">Service Name</ion-label>
        <ion-select
          formControlName="serviceSelector"
          (ionChange)="refreshNumberOfRecipients()"
        >
          <div *ngFor="let serviceCategory of serviceCategories">
            <ion-select-option
              *ngFor="
                let serviceDefinition of serviceCategory.serviceDefinitions
              "
              [value]="serviceDefinition.name"
            >
              {{ serviceDefinition.name }}
            </ion-select-option>
          </div>
        </ion-select>
      </ion-item>
    </div>
  </ng-container>
  <ion-item>
    <p *ngIf="dateError.isError" class="sm-error">
      {{ dateError.errorMessage }}
    </p></ion-item
  >
  <ion-item lines="none">
    <ion-label color="primary"> This will be sent to {{ selectedRecipients.length }} clients <ion-icon name="eye" class="eye-icon"></ion-icon></ion-label>
    <ionic-selectable
      class="selected-recipients"
      [(ngModel)]="selectedRecipients"
      [ngModelOptions]="{ standalone: true }"
      [items]="recipients"
      itemValueField="clientID"
      itemTextField="name"
      [canSearch]="true"
      [isMultiple]="true"
    >
    </ionic-selectable>
  </ion-item>

  <ion-spinner icon="crescent" *ngIf="loadingRecipients"></ion-spinner>

  <ion-card>

    <ion-item lines="none">

      <ion-textarea rows="10" formControlName="bulkText"></ion-textarea>
    </ion-item>
  </ion-card>
</form>
<ion-note>Cost: {{ segmentCount }} text segment(s) x {{ selectedRecipients.length }} recipients x $0.05/message = {{ (segmentCount * selectedRecipients.length * 0.05) | salonMonsterCurrency }}</ion-note>
<br />

<ion-row>
  <ion-col>
    <ion-button expand="block" (click)="send()" [disabled]="dateError.isError"
      >Send it</ion-button
    >
  </ion-col>
</ion-row>
